import nullable from "./nullable";
import * as t from "io-ts";
import { financeUnitsT } from "./finance";
export const productT = t.strict({
    id: t.string,
    productNumber: t.string,
    name: t.string,
    salesPrice: nullable(t.string),
    shouldBeGroupedInConsolidated: t.boolean,
    visibleToDrivers: t.boolean,
});
export const surchargeT = t.intersection([
    productT,
    t.strict({
        isSurchargeForProducts: t.array(t.string),
        isRoadTollSurcharge: t.boolean,
    }),
]);
export const productsT = t.array(productT);
export const surchargesT = t.array(surchargeT);
const createProductT = ({ decimalT, }) => t.strict({
    id: t.string,
    unitId: nullable(t.string),
    productNumber: t.string,
    name: t.string,
    salesPrice: nullable(decimalT),
    surcharges: t.array(t.string),
    shouldBeGroupedInConsolidated: t.boolean,
    visibleToDrivers: t.boolean,
    productGroupId: nullable(t.string),
});
const createSurchargeT = ({ decimalT, }) => t.strict({
    id: t.string,
    unitId: nullable(t.string),
    productNumber: t.string,
    name: t.string,
    salesPrice: nullable(decimalT),
    percentage: nullable(decimalT),
    isRoadTollSurcharge: t.boolean,
    shouldBeGroupedInConsolidated: t.boolean,
    visibleToDrivers: t.boolean,
    shouldApplyToNewCustomers: t.boolean,
});
const createPricingAgreementT = ({ decimalT, }) => t.strict({
    id: t.string,
    clientId: t.string,
    unitId: nullable(t.string),
    unitNumber: nullable(t.number),
    productId: t.string,
    name: nullable(t.string),
    salesPrice: decimalT,
    discountPercentage: nullable(decimalT),
});
export const createProductsAndSurcharges = ({ decimalT, }) => t.strict({
    products: t.array(createProductT({ decimalT })),
    surcharges: t.array(createSurchargeT({ decimalT })),
});
export const createProductsSurchargesAndAgreements = ({ decimalT, }) => t.strict({
    products: t.array(createProductT({ decimalT })),
    surcharges: t.array(createSurchargeT({ decimalT })),
    pricingAgreements: t.array(createPricingAgreementT({ decimalT })),
});
export const createFinanceDataForDriver = ({ decimalT, }) => {
    const financeDataT = t.strict({
        products: t.array(createProductT({ decimalT })),
        surcharges: t.array(createSurchargeT({ decimalT })),
        units: financeUnitsT,
    });
    const pricingAgreementT = createPricingAgreementT({ decimalT });
    const pricingAgreementsT = t.array(pricingAgreementT);
    return {
        pricingAgreementT,
        pricingAgreementsT,
        financeDataT,
    };
};
//# sourceMappingURL=products.js.map